// extracted by mini-css-extract-plugin
export default {"wrapper":"EditClientGeneralForm_wrapper__aRDr9","submitWrapper":"EditClientGeneralForm_submitWrapper__AvvLc"};